export default "__VITE_ASSET__YA594oen__"